import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { WattsLogo } from "@/components/WattsLogo";

export const Route = createFileRoute("/forgot-password")({
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });
      if (error) throw error;
      setSent(true);
      toast.success("Revisa tu email");
    } catch (err: any) {
      toast.error(err?.message || "No se pudo enviar el email.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-xl bg-[#1a1a1a] border border-[#2a2a2a] px-4 text-white placeholder:text-[#666] outline-none transition-colors focus:border-[#F5C518] focus:ring-2 focus:ring-[#F5C518]/30";

  return (
    <div className="flex min-h-screen flex-col bg-[#0f0f0f] fade-in">
      <div className="flex flex-col items-center px-6 pt-8 pb-3 text-center">
        <WattsLogo width={180} />
      </div>
      <div className="flex justify-center"><div className="h-px w-10 bg-[#F5C518]/70" /></div>

      <div className="flex-1 px-6 pt-8 pb-[max(env(safe-area-inset-bottom),1.5rem)]">
        <div className="mx-auto w-full max-w-sm">
          <Link to="/auth" className="mb-6 inline-flex items-center gap-1.5 text-sm text-[#888] hover:text-white">
            <ArrowLeft className="h-4 w-4" /> Volver
          </Link>

          <h1 className="font-display text-2xl text-white mb-2">Recuperar contraseña</h1>
          <p className="text-sm text-[#888] mb-6">
            Introduce tu email y te enviaremos un enlace para crear una nueva contraseña.
          </p>

          {sent ? (
            <div className="rounded-xl border border-[#2a2a2a] bg-[#1a1a1a] p-5 text-center">
              <p className="text-sm text-white">📬 Si existe una cuenta con <b>{email}</b>, te llegará un enlace en unos segundos.</p>
              <p className="mt-3 text-xs text-[#888]">Revisa tu bandeja de entrada y la carpeta de spam.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-3">
              <input
                type="email" inputMode="email" autoComplete="email" required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@email.com"
                style={{ height: 52 }}
                className={inputCls}
              />
              <button
                type="submit"
                disabled={loading}
                style={{ height: 52 }}
                className="press-scale w-full rounded-xl bg-[#F5C518] font-bold text-black disabled:opacity-50"
              >
                {loading ? "Enviando…" : "Enviar link de recuperación"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
